function Dice(props) {
    
    const dotClass = props.isHeld ? "dot isHeld" : "dot" 
    const diceClass = props.isHeld ? "dice isHeld" : "dice"
    const Dot = () => <span className="dot" />
return (
        <div className={diceClass} onClick={props.clickHandler}>
            {[...Array(props.value)].map((x, i) => 
                <Dot key={i} />
                )}
        </div>
    )
}

export default Dice;